var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Files_-_PDF",
    "data-name": "Files - PDF",
    transform: "translate(0 -0.513)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2914",
    "data-name": "Rectangle 2914",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(0 0.513)",
    fill: "#c80a0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34055",
    "data-name": "Path 34055",
    d: "M108.554,108.1a3.511,3.511,0,0,0-2.616-.743,15.928,15.928,0,0,0-2.475.248,12.444,12.444,0,0,1-2.429-3.417,14.582,14.582,0,0,0,.794-4.012c0-.842-.28-2.179-1.4-2.179a.955.955,0,0,0-.794.5c-.467.892-.28,2.873.607,4.953a45.956,45.956,0,0,1-2.335,5.795c-2.475,1.09-4.11,2.278-4.25,3.219a1.04,1.04,0,0,0,1.168,1.189c1.448,0,3.036-2.229,4.25-4.507a27.908,27.908,0,0,1,4.3-1.189,6.119,6.119,0,0,0,4.063,1.882C108.928,109.837,109.068,108.7,108.554,108.1Zm-8.687-9.46c.374-.594,1.214-.4,1.214.792a13.282,13.282,0,0,1-.7,3.566C99.54,100.922,99.54,99.288,99.867,98.644Zm-5.932,13.868c.14-.792,1.541-1.882,3.737-2.823-1.214,2.179-2.429,3.566-3.176,3.566A.6.6,0,0,1,93.935,112.512Zm9.2-4.854a25.6,25.6,0,0,0-3.877,1.09,23.177,23.177,0,0,0,1.681-4.16A16.143,16.143,0,0,0,103.136,107.658Zm.607.2a11.055,11.055,0,0,1,3.316-.1c1.354.3.887,2.031-.607,1.634A6.48,6.48,0,0,1,103.743,107.856Z",
    transform: "translate(-89.264 -93.368)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.f86a6a4227b6673ba155eac57409b2bd.svg";
export { ForwardRef as ReactComponent };